export default {
  data () {
    return {
      SHOP_ACTIVE: 0,
      SHOP_DISABLED: 1, 
      SHOP_LOCKED: 2,
      UNIT_MINUTE: 1,
      UNIT_HOUR: 2,
      UNIT_DAY: 3,
      TYPE_BUYABLE: 0,
      TYPE_SELLABLE: 0,
      TYPE_RESERVABLE: 1,
      SUBTYPE_GENERIC: 0,
      SUBTYPE_CABIN: 1,
      SUBTYPE_ACTIVITY: 2,
      SUBTYPE_TRANSPORTATION: 3,
      SUBTYPE_EVENT: 4,
      SUBTYPE_TICKET: 5,
      SUBTYPE_VALUECARD: 6,
      SUBTYPE_EXCHANGED_VALUECARD: 7,
      SUBTYPE_CONTENT: 8,
      SUBTYPE_EXTERNAL: 1000,
      SUBTYPE_HOTELLINX: 1001,
      PRICING_NORMAL: 0, // Normal pricing
      PRICING_HIDE_OPEN: 1, // Open order, hide pricing
      PRICING_DISABLED: 2, // Disable buying/reserving
      PRICING_SHOW_OPEN: 3, // Open order, show pricing
      PRICING_SHOW_OPEN_ALLOWPAYMENT: 4, // Open order, show pricing, allow payment
      PRICING_TICKET: 5, // Ticket pricing
      PRICING_SHOW_CONFIRMED: 6, // Confirmed order, show pricing
      PRICING_HIDE_CONFIRMED: 7, // Confirmed order, hide pricing
      COMMISSION_FIXED: 0,
      COMMISSION_PERCENTAGE: 1,
      INTERNALDURATION_RESERVATION: 0,
      INTERNALDURATION_PRICEROW: 1,
      ORDER_NOT_CONFIRMED: 0,
      ORDER_CONFIRMED: 1, 
      ORDER_BILLED_AND_NOT_CONFIRMED: 2,
      ORDER_CONSOLIDATED: 3,
      ORDER_BILLED_AND_CONFIRMED: 4,
      CHANNEL_UNPROCESSED: 0,
      CHANNEL_APPROVED: 1,
      CHANNEL_REJECTED: 2,
      CHANNEL_ACCEPTED: 3,
      STATUS_NOTACKNOWLEDGED: 0,
      STATUS_ACKNOWLEDGED: 1,
      LINKEDPRODUCT_MANDATORY: 0,
      LINKEDPRODUCT_OFFER: 1,
      LINKEDPRODUCT_OPTIONAL: 2,
      LINKEDPRODUCT_HIDDEN: 3,
      LINKEDPRODUCT_PACKAGED: 4,
      allVersions: [
        { 
          identifier: "fi_FI",
          abbreviation: "FI",
          name: "Suomi"
        },
        { 
          identifier: "en_US",
          abbreviation: "EN",
          name: "English"
        },
        { 
          identifier: "sv_SE",
          abbreviation: "SV",
          name: "Svenska"
        },
        { 
          identifier: "de_DE",
          abbreviation: "DE",
          name: "Deutsch"
        },
        { 
          identifier: "it_IT",
          abbreviation: "IT",
          name: "Italiano"
        },
        { 
          identifier: "es_ES",
          abbreviation: "ES",
          name: "Espa\u00f1ol"
        },
        { 
          identifier: "fr_FR",
          abbreviation: "FR",
          name: "Fran\u00e7ais"
        },
        { 
          identifier: "nb_NO",
          abbreviation: "NO",
          name: "Norsk"
        },
        { 
          identifier: "ru_RU",
          abbreviation: "RU",
          name: "\u0440\u0443\u0441\u0441\u043a\u0438\u0439"
        }
      ]
    }
  },
  methods: {
    getVersionName (version) {
      if (this.allVersions) {
        const v = this.allVersions.find(v => v.identifier === version)
        if (v) {
          return v.name
        }
      }
      return version
    },
    getShortVersionName (version) {
      if (this.allVersions) {
        const v = this.allVersions.find(v => v.identifier === version)
        if (v) {
          return v.abbreviation
        }
      }
      return version.split('_')[0].toUpperCase()
    }
  }
}
